export default __webpack_public_path__ + "static/media/resources.592f0704.svg";